<div class="card shadow">
  <div class="card-body d-flex cursor-pointer" (click)="open()">
    <app-file-icon [path]="$safeNavigationMigration(document.fichier?.url)"></app-file-icon>
    <span class="ellips">{{document.nom}}</span>
  </div>
</div>
